import Swal from 'sweetalert2';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import type {CourseId, UserId} from 'types/common';
import type {TranslationFunction} from 'components/translation/utils';

export const getDemoVideoStoragePath = (userId: UserId): string => {
  return `slDemoVideos/${userId}`;
};

export const getTeachNowTrainingVideoStoragePath = (
  courseId?: CourseId,
  userId?: UserId,
): string => {
  return `teachNowTrainingVideos/${courseId}/${userId}`;
};

export const uploadVideo = (
  setVideoUrl: (url: string) => void,
  setUploadProgress: (progress: number) => void,
  setErrorState: (error: Error | null) => void,
  demoVideoStoragePath: string,
  t: TranslationFunction | null = null,
  existingfile = '',
): void => {
  if (!existingfile) {
    Swal.fire({
      title: !t ? 'Select Video' : (t('Select video') as string),
      input: 'file',
      inputAttributes: {
        accept: 'video/*',
        'aria-label': !t
          ? 'Upload your demo video'
          : (t('Upload your demo video') as string),
      },
    }).then(e => {
      const file = e.value;
      if (file) {
        uploadVideoFile(
          file,
          setVideoUrl,
          setUploadProgress,
          setErrorState,
          demoVideoStoragePath,
        );
      }
    });
  } else {
    uploadVideoFile(
      existingfile,
      setVideoUrl,
      setUploadProgress,
      setErrorState,
      demoVideoStoragePath,
    );
  }
};

const uploadVideoFile = (
  file,
  setVideoUrl: (url: string) => void,
  setUploadProgress: (progress: number) => void,
  setErrorState: (error: Error | null) => void,
  demoVideoStoragePath,
) => {
  // lets get this started
  setUploadProgress(1);

  const storage = firebase.storage();
  const storageRef = storage.ref();

  const uploadTask = storageRef.child(demoVideoStoragePath).put(file);

  uploadTask.on(
    firebase.storage.TaskEvent.STATE_CHANGED,
    snapshot => {
      const progress = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
      );
      setUploadProgress(progress);
    },
    error => {
      setErrorState(error);
    },
    () => {
      // get a playable url from the snapshop ref
      const ref = uploadTask.snapshot.ref;
      ref.getDownloadURL().then(url => {
        setVideoUrl(url);
      });
    },
  );
};
